/*****************************************************************************
*
* MCAFEE CONFIDENTIAL
* Copyright (c)2019 McAfee, LLC
*
* The source code contained or described herein and all documents related
* to the source code ("Material") are owned by McAfee or its
* suppliers or licensors. Title to the Material remains with McAfee
* or its suppliers and licensors. The Material contains trade
* secrets and proprietary and confidential information of McAfee or its
* suppliers and licensors. The Material is protected by worldwide copyright
* and trade secret laws and treaty provisions. No part of the Material may
* be used, copied, reproduced, modified, published, uploaded, posted,
* transmitted, distributed, or disclosed in any way without McAfee's prior
* express written permission.
*
* No license under any patent, copyright, trade secret or other intellectual
* property right is granted to or conferred upon you by disclosure or
* delivery of the Materials, either expressly, by implication, inducement,
* estoppel or otherwise. Any license under such intellectual property rights
* must be expressed and approved by McAfee in writing.
*
****************************************************************************/

import { ca_engine_queuehandler } from "./bootstrap_web_ext";
import { globalEngine } from "./Init";
//const expressions for dimesnsions

     var KEY_UNIQUEIDENTIFIER = "UniqueIdentifier";
     var KEY_FEATURE = "Feature";
     var KEY_TRIGGER = "Trigger";
     var KEY_INTERACTIVE = "Interactive";
     var KEY_DESIRED = "Desired";
     var KEY_USERINITIATED = "UserInitiated";
     var KEY_USERIDENTIFIER = "UserIdentifier";
     var KEY_LABEL1 = "Hit.Label.1";
     var KEY_LABEL2 = "Hit.Label.2";
     var KEY_LABEL3 = "Hit.Label.3";
     var KEY_LABEL4 = "Hit.Label.4";
     var KEY_LABEL5 = "Hit.Label.5";
     var KEY_LABEL6 = "Hit.Label.6";
     var KEY_SCREEN = "Screen";
     var KEY_GUID = "Hit.GUID";
  
    // Common/Reserved for internal use
     var KEY_RESERVED1 = "Reserved1";
     var KEY_RESERVED2 = "Reserved2";
     var KEY_RESERVED3 = "Reserved3";
     var KEY_RESERVED4 = "Reserved4";
     var KEY_RESERVED5 = "Reserved5";

    // Event-specific
     var KEY_EVENTCATEGORY = "Event.Category";
     var KEY_EVENTACTION = "Event.Action";
     var KEY_EVENTLABEL = "Event.Label";
     var KEY_EVENTVALUE = "Event.Value";
	 
	//Exception Specific
	 var KEY_EXCEPTIONDETAIL = "Exception.Detail";
     var KEY_EXCEPTIONCRASH = "Exception.Crash";



//Event class for creating new events
export var Event = function(eventId)
{
  this.eEventId = eventId;
  this.jsonMap ={};

};



Event.prototype.UniqueIdentifier = function (data)
{
 this.jsonMap[KEY_UNIQUEIDENTIFIER] = data;
 return this;
};

Event.prototype.Feature = function (data)
{
 this.jsonMap[KEY_FEATURE] = data;
 return this;
};

Event.prototype.Trigger = function (data)
{
 this.jsonMap[KEY_TRIGGER] = data;
 return this;
};

Event.prototype.Interactive = function (data)
{
 this.jsonMap[KEY_INTERACTIVE] = data;
 return this;
};

Event.prototype.Desired = function (data)
{
 this.jsonMap[KEY_DESIRED] = data;
 return this;
};

Event.prototype.UserInitiated = function (data)
{
 this.jsonMap[KEY_USERINITIATED] = data;
 return this;
};

Event.prototype.UserIdentifier = function (data)
{
 this.jsonMap[KEY_USERIDENTIFIER] = data;
 return this;
};

Event.prototype.Label1 = function (data)
{
 this.jsonMap[KEY_LABEL1] = data;
 return this;
};

Event.prototype.Label2 = function (data)
{
 this.jsonMap[KEY_LABEL2] = data;
 return this;
};

Event.prototype.Label3 = function (data)
{
 this.jsonMap[KEY_LABEL3] = data;
 return this;
};

Event.prototype.Label4 = function (data)
{
 this.jsonMap[KEY_LABEL4] = data;
 return this;
};

Event.prototype.Label5 = function (data)
{
 this.jsonMap[KEY_LABEL5] = data;
 return this;
};

Event.prototype.Label6 = function (data)
{
 this.jsonMap[KEY_LABEL6] = data;
 return this;
};

Event.prototype.Screen = function (data)
{
 this.jsonMap[KEY_SCREEN] = data;
 return this;
};

Event.prototype.GUID = function (data)
{
 this.jsonMap[KEY_GUID] = data;
 return this;
};

Event.prototype.Reserved1 = function (data)
{
 this.jsonMap[KEY_RESERVED1] = data;
 return this;
};

Event.prototype.Reserved2 = function (data)
{
 this.jsonMap[KEY_RESERVED2] = data;
 return this;
};

Event.prototype.Reserved3 = function (data)
{
 this.jsonMap[KEY_RESERVED3] = data;
 return this;
};

Event.prototype.Reserved4 = function (data)
{
 this.jsonMap[KEY_RESERVED4] = data;
 return this;
};

Event.prototype.Reserved5 = function (data)
{
 this.jsonMap[KEY_RESERVED5] = data;
 return this;
};

Event.prototype.Category = function (data)
{
 this.jsonMap[KEY_EVENTCATEGORY] = data;
 return this;
};

Event.prototype.Action = function (data)
{
 this.jsonMap[KEY_EVENTACTION] = data;
 return this;
};

Event.prototype.Label = function (data)
{
 this.jsonMap[KEY_EVENTLABEL] = data;
 return this;
};

Event.prototype.Value = function (data)
{
 this.jsonMap[KEY_EVENTVALUE] = data;
 return this;
};

Event.prototype.ExceptionDetail = function (data)
{
 this.jsonMap[KEY_EXCEPTIONDETAIL] = data;
 return this;
};

Event.prototype.ExceptionCrash = function (data)
{
 this.jsonMap[KEY_EXCEPTIONCRASH] = data;
 return this;
};

Event.prototype.Add = function (key,data)
{
  this.jsonMap[key]= data;
  return this;
};

Event.prototype.Finish = function ()
{
   var result = Object.keys(this.jsonMap).map(k => ({ [k]: this.jsonMap[k] }));
   var jsonData = {};
   jsonData["unique_id"] = this.eEventId;
   jsonData["type"] = "UWP_Event";
   jsonData["data"] = result;
   var JsonString = JSON.stringify(jsonData);
   //passing the event json to SDK Engine
   ca_engine_queuehandler(JsonString);
};


export function run(){

	new Event("uwp_heartbeat").Finish();


}
var shutDownDefAvailable = false;

export function shutDownProcessing()
{
  //cleanup is done after client signals for shut-down.
   shutDownDefAvailable = true;
   globalEngine.__cleanAll();
}

//default shutDown Implementation
window.addEventListener("beforeunload", function (e) {

 if(!shutDownDefAvailable)
 {
    globalEngine.__cleanAll();
 }
 
});
